import { useSearchParams } from "next/navigation";
import { useEffect, useState } from "react";

import type { WithStylexArray } from "../../../types";
import { AuthMainFlow } from "./AuthMainFlow";
import type { AuthFlow, AuthFlowProps, AuthProps } from "./AuthTypes";

export type SimplifiedAuthProps = WithStylexArray<{
  onFlowChange: (flow: AuthFlow) => void;
  onAuth: AuthFlowProps["onAuth"];
  allowedMethods?: AuthProps["allowedMethods"];
}>;

export const SimplifiedAuth = ({
  onFlowChange,
  allowedMethods = ["email", "phone", "apple", "google"],
  onAuth,
  styleXArray = [],
}: SimplifiedAuthProps) => {
  const searchParams = useSearchParams();
  const [flow, setFlow] = useState<AuthFlow>(
    (searchParams.get("flow") as AuthFlow) || "main",
  );

  useEffect(() => {
    if (flow !== "main") {
      onFlowChange(flow);
    }
  }, [flow]);

  return (
    <AuthMainFlow
      flow={flow}
      setFlow={setFlow}
      onAuth={onAuth}
      allowedMethods={allowedMethods}
      styleXArray={styleXArray}
    />
  );
};
